import React, { useState, useContext } from 'react'
import Logo from '../assets/img/logoLTR.png'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/usercontext'

const NavbarSA = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true)
  const navigate = useNavigate()

  const { user } = useAuth()
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed)

  const handleLogout = () => {
    localStorage.removeItem('token')
    navigate('/')
  }

  return (
    <nav className='navbar navbar-expand-lg bg-body-tertiary fixed-top shadow-sm'>
      <div className='container-fluid'>
        <span className='navbar-brand'>
          <img src={Logo} height='40' alt='Logo' className='mx-2' />
        </span>

        <button
          className='navbar-toggler'
          type='button'
          aria-expanded={!isNavCollapsed}
          aria-label='Toggle navigation'
          onClick={handleNavCollapse}
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`}>
          <ul className='navbar-nav me-auto'></ul>

          {user && (
            <div className='dropdown'>
              <button
                className='btn d-flex align-items-center gap-2 dropdown-toggle'
                type='button'
                data-bs-toggle='dropdown'
                aria-expanded='false'
                style={{ color: '#0d6efd' }}
              >
                <i className='bi bi-person-circle fs-5'></i>
                <span className='fw-semibold'>{user.name.split(' ')[0]}</span>
              </button>

              <ul className='dropdown-menu dropdown-menu-end shadow-sm'>
                <li className='dropdown-item-text small text-muted'>
                  {user.email}
                </li>

                <li>
                  <Link className='dropdown-item' to='/admin/dashboard'>
                    <i className='bi bi-person me-2'></i>
                    Profile
                  </Link>
                </li>

                <li>
                  <hr className='dropdown-divider' />
                </li>

                <li>
                  <button
                    className='dropdown-item text-danger'
                    onClick={handleLogout}
                  >
                    <i className='bi bi-power me-2'></i>
                    Logout
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}

export default NavbarSA
